"use client";

import { FaBookBookmark } from "react-icons/fa6";

export default function Page() {
    return (
        <div className="flex flex-row min-h-[calc(100vh-10rem)] gap-12 pt-10 text-white w-full">
            <div className="flex flex-col lg:flex-row w-full lg:justify-between max-w-screen-2xl lg:mx-auto px-16 gap-16">
                <div className="flex flex-col h-fit">
                    <div className="flex flex-col items-center justify-center">
                        <h1 className="text-4xl font-bold text-center"><span className="text-[#00FF35]"><FaBookBookmark className="inline-block size-8" /> In-Game</span> Server Rules</h1>
                        <h2 className="text-lg text-center">Last Updated {new Date(1756482300000).toLocaleString()}</h2>
                    </div>
                    <ol className="list-decimal list-outside flex flex-col gap-1 text-xl font-roboto-mono">
                        <li><span className="font-semibold">Cheating or exploiting game or plugin bugs is strictly prohibited.</span></li>
                        <li><span className="font-semibold">Attempting to bypass or evade any issued punishments is forbidden.</span></li>
                        <li><span className="font-semibold">
                            Do not start arguments, attack, discriminate or use offensive language.
                            <ul className="list-disc list-inside ml-6 mt-1">
                                <li><span className="font-semibold">Friendly banter and harmless jokes are allowed.</span></li>
                            </ul>
                        </span></li>
                        <li><span className="font-semibold">Do not impersonate other players or staff.</span></li>
                        <li><span className="font-semibold">Advertising other servers etc. and adult content are prohibited.</span></li>
                        <li><span className="font-semibold">Soundboards may only be used in proximity chat and must not be too loud, contain music or break the rules.</span></li>
                        <li><span className="font-semibold">Spawn camping is prohibited.</span></li>
                        <li><span className="font-semibold">Do not intentionally harm your team, excluding Class D.</span></li>
                        <li><span className="font-semibold">Kill On Sight is allowed but killing cuffed Class D or Scientists is prohibited.</span></li>
                        <li><span className="font-semibold">Round stalling is not allowed.</span></li>
                    </ol>
                </div>
                <div className="flex flex-col h-fit">
                    <div className="flex flex-col items-center justify-center">
                        <h1 className="text-4xl font-bold text-center"><span className="text-[#00B2FF]"><FaBookBookmark className="inline-block size-8" /> Discord</span> Server Rules</h1>
                        <h2 className="text-lg text-center">Last Updated {new Date(1756482300000).toLocaleString()}</h2>
                    </div>
                    <ol className="list-decimal list-outside flex flex-col gap-1 text-xl font-roboto-mono">
                        <li><span className="font-semibold">Treat others with respect and avoid drama or provocation.</span></li>
                        <li><span className="font-semibold">Keep conversations on topic and in the proper channels.</span></li>
                        <li><span className="font-semibold">No advertisements, server invites, or spam allowed.</span></li>
                        <li><span className="font-semibold">No NSFW or disturbing content anywhere (including nicknames and profiles).</span></li>
                        <li><span className="font-semibold">Do not harass or discriminate against anyone based on appearance, origin, orientation, or beliefs.</span></li>
                        <li><span className="font-semibold">Do not impersonate others.</span></li>
                        <li><span className="font-semibold">
                            Do not ping server staff without a valid reason.
                            <ul className="list-disc list-inside ml-6 mt-1">
                                <li><span className="font-semibold">Contact a moderator if you have a problem or see someone violating the rules.</span></li>
                            </ul>
                        </span></li>
                    </ol>
                </div>
            </div>
        </div>
    );
}
